import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Plus, Minus, Trash2, ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';

const CartDrawer = () => {
  const { items, isOpen, setIsOpen, updateQty, removeItem, total, count, clearCart } = useCart();
  const navigate = useNavigate();

  return (
    <>
      {/* overlay */}
      <div
        className={`fixed inset-0 bg-black/50 z-[60] transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        onClick={() => setIsOpen(false)}
      />
      {/* drawer */}
      <aside
        className={`fixed top-0 right-0 h-full w-full max-w-md bg-white z-[70] shadow-2xl flex flex-col transition-transform duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className="ps-blue-bg text-white px-6 py-5 flex items-center justify-between">
          <h2 className="font-anton text-xl flex items-center gap-2"><ShoppingBag size={22} /> YOUR CART ({count})</h2>
          <button onClick={() => setIsOpen(false)} className="p-1.5 rounded-full hover:bg-white/15"><X size={22} /></button>
        </div>

        <div className="flex-1 overflow-y-auto p-5">
          {items.length === 0 ? (
            <div className="h-full flex flex-col items-center justify-center text-center text-gray-400">
              <ShoppingBag size={56} className="mb-4 opacity-40" />
              <p className="font-oswald uppercase text-lg">Your cart is empty</p>
              <button onClick={() => { setIsOpen(false); navigate('/products'); }} className="mt-4 ps-blue-bg text-white px-5 py-2 rounded-lg font-oswald uppercase text-sm btn-press">Shop Now</button>
            </div>
          ) : (
            <div className="space-y-4">
              {items.map((item) => (
                <div key={item.id} className="flex gap-3 bg-gray-50 rounded-xl p-3">
                  <img src={item.image} alt={item.name} className="w-20 h-20 rounded-lg object-cover" />
                  <div className="flex-1 min-w-0">
                    <h3 className="font-oswald text-gray-900 leading-tight truncate">{item.name}</h3>
                    <div className="flex items-center gap-2 mt-2">
                      <button onClick={() => updateQty(item.id, item.qty - 1)} className="w-7 h-7 rounded-md bg-white border flex items-center justify-center hover:bg-gray-100"><Minus size={14} /></button>
                      <span className="w-6 text-center font-medium">{item.qty}</span>
                      <button onClick={() => updateQty(item.id, item.qty + 1)} className="w-7 h-7 rounded-md bg-white border flex items-center justify-center hover:bg-gray-100"><Plus size={14} /></button>
                      <button onClick={() => removeItem(item.id)} className="ml-auto text-gray-400 hover:text-red-500"><Trash2 size={16} /></button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {items.length > 0 && (
          <div className="border-t p-5 space-y-3">
            <button onClick={() => alert('This is a demo store. Checkout is not connected to a backend yet.')} className="w-full ps-yellow-bg text-black py-3.5 rounded-xl font-oswald uppercase tracking-wide text-lg btn-press hover:bg-[#f0c000]">Checkout</button>
            <button onClick={clearCart} className="w-full text-sm text-gray-400 hover:text-red-500">Clear cart</button>
          </div>
        )}
      </aside>
    </>
  );
};

export default CartDrawer;
